import Translator from '../Translator';
import { get } from '../../../utils';
import DeviceDetector from '../../components/DeviceDetector';

export const getLocale = () => Translator.getLocale();

const defaultConfig = {
    enabled: false,
    locales: ['en-gb'],
    enabledDeviceTypes: ['desktop'],
};

const getConfig = () => get(window, 'whStatic.config.stories', defaultConfig);

const isDeviceEnabled = ({ enabledDeviceTypes }) => {
    const deviceType = DeviceDetector.getDeviceType();
    return enabledDeviceTypes.includes(deviceType);
};

const isLocaleEnabled = ({ locales }) => {
    return locales.includes(getLocale());
};

const isFeatureEnabled = ({ enabled }) => {
    return enabled;
};

export const isStoriesActive = () => {
    const config = getConfig();
    return isFeatureEnabled(config) && isLocaleEnabled(config) && isDeviceEnabled(config);
};
